import { Inject, Injectable,NgZone,signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})


export class CommonService {
  private observer!: MutationObserver;
  private inputFields: NodeListOf<HTMLInputElement> | null = null;
  private retryCount = 0;

  public scrollEnd = new Subject<boolean>();

  public scrollEnd$ = this.scrollEnd.asObservable(); 

  public updateScrollSubject(newScrollEnd: boolean) {
    this.scrollEnd.next(newScrollEnd);
  }
  
  private quoteStoredData = signal<any>({});
  loadingState = signal<boolean>(false);
  registerLogged = signal<number>(1);
  uploadProgress = signal<number | null>(null);

  updateloadingState(value: any) {
    this.loadingState.set(value);
  }

  getloadingState() {
    return this.loadingState;
  }

  updateUploadProgress(value: number | null) {
    this.uploadProgress.set(value);
  }

  getUploadProgress() {
    return this.uploadProgress;
  }
  
  updateQuoteStoredData(value: any) {
    this.quoteStoredData.set(value);
  }
  
  getQuoteStoredData() {
    return this.quoteStoredData;
  }

  setQuoteCallback() {
    this.registerLogged.set(Math.random());
  }
  
  getQuoteCallback() {
    return this.registerLogged;
  }
  constructor(@Inject(DOCUMENT) private doc: any,
  private ngZone: NgZone) {}


  initPhoneFields() {
    this.observeFormChanges();
    this.findInputFields();
  }

  /** Finds and updates all phone input fields */
  findInputFields() {
    setTimeout(() => {
      this.inputFields = document.querySelectorAll('.iti input');

      if (this.inputFields.length) {
        this.inputFields.forEach((inputField: HTMLInputElement) => {
          this.modifyPlaceholder(inputField);
          this.observePlaceholderChanges(inputField);
        });
      }
    }, 500);
  }

  /** Observes the DOM for new phone fields */
  observeFormChanges() {
    this.observer = new MutationObserver(() => {
      this.findInputFields(); // Re-run logic whenever new fields are added
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  /** Watches for placeholder changes */
  observePlaceholderChanges(inputField: HTMLInputElement) {
    const mutationObserver = new MutationObserver(() => {
      this.modifyPlaceholder(inputField);
    });

    mutationObserver.observe(inputField, {
      attributes: true,
      attributeFilter: ['placeholder'],
    });

    this.modifyPlaceholder(inputField);
  }

  /** Updates the placeholder text */
  modifyPlaceholder(inputField: HTMLInputElement) {
    const currentPlaceholder = inputField.getAttribute('placeholder');
    if (currentPlaceholder && !currentPlaceholder.startsWith('ex. ')) {
      this.ngZone.runOutsideAngular(() => {
        inputField.setAttribute('placeholder', `ex. ${currentPlaceholder}`);
      });
    }
  }

  /** Cleanup */
  stopObserving() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
